import servicePhysioImage from "../../assets/images/Gyógytorna.jpg";
import serviceManualImage from "../../assets/images/Manuálterápia.jpg";
import serviceTapeImage from "../../assets/images/Kiegészítő.jpg";
import IndicationsSection from "./IndicationsSection";
import SectionHeading from "../shared/SectionHeading";
import "./ServicesSection.css";

const services = [
  {
    title: "Gyógytorna",
    image: servicePhysioImage,
    description:
      "vagy más néven fizioterápia - egy mozgásterápiás eljárás, amely a test természetes mozgásait alkalmazza a különböző mozgásszervi és idegrendszeri problémák kezelésére, megelőzésére és rehabilitációjára. Tudományosan megalapozott módszer, amely célzott, szakember által vezetett mozgásgyakorlatokon alapul. A gyógytorna lényege, hogy a test öngyógyító folyamatait támogatja, miközben javítja az izomerőt, az ízületi mozgásterjedelmet, a testtartást, valamint csökkenti a fájdalmat és a gyulladást.",
  },
  {
    title: "Manuálterápia",
    image: serviceManualImage,
    description:
      "egy speciális, kézzel végzett kezelési forma, amelyet mozgásszervi problémák - például ízületi merevség, izomfeszülés vagy fájdalom - enyhítésére és megszüntetésére alkalmazunk. A kezelés során a terapeuta célzott, precíz fogásokkal, mobilizációs és nyújtási technikákkal dolgozik az érintett ízületeken, izmokon, idegpályákon. A cél a mozgástartomány növelése, a fájdalom csökkentése és a test egyensúlyának visszaállítása.",
  },
  {
    title: "Kiegészítő kezelések",
    image: serviceTapeImage,
    description:
      "a gyógytorna hatékonyságának növelésére. A kiegészítő terápiák a gyógytornával kombinálva hozzájárulnak a gyorsabb regenerációhoz és a tartósabb eredményekhez. Két gyakran alkalmazott módszer a Kinesio Tape vagy az SMR (Self Myofascial Release) Henger",
  },
];

function ServicesSection() {
  return (
    <>
      <section className="section" id="szolgaltatasok">
        <SectionHeading
          eyebrow="Szolgáltatások"
          title="Komplex mozgásszervi támogatás"
          centered
        />

        <div className="services-grid">
          {services.map((service) => (
            <article className="service-card" key={service.title}>
              <img
                src={service.image}
                alt={service.title}
                loading="lazy"
                decoding="async"
              />
              <div className="service-card__body">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <IndicationsSection />
    </>
  );
}

export default ServicesSection;
